import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { StyledLogoLink, StyledPostMagazineLogoFlag } from "./styles";

export type PostMagazineLogoLinkProps = HeaderFeatureCommonProps;

export const PostMagazineLogoLink: FunctionComponent<PostMagazineLogoLinkProps> = ({
  ...props
}) => (
  <StyledLogoLink pathname="/" {...getResponsiveProps(props)}>
    <StyledPostMagazineLogoFlag />
  </StyledLogoLink>
);

PostMagazineLogoLink.displayName = "PostMagazineLogoLink";
